const styles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    flex: 1,
    backgroundColor: theme.ModalBGColor,
  },
  moduleHeader: {
    color: theme.HeaderSelectedText,
    borderBottom: `1px solid ${theme.AppBGColor}`,
    fontWeight: "bold",
    padding: `10px 32px`,
    fontSize: 14,
  },
  moduleContainer: {
    padding: 32,
    display: "flex",
  },
  formContainer: {
    padding: "20px 20px 0px 20px",
  },
  formLabel: {
    fontWeight: 500,
    fontSize: theme.textFontSize,
    lineHeight: "19px",
    color: theme.iconColor,
    width: "30%",
    paddingRight: "10px",
  },
  formValue: {
    width: "100%",
    display: "flex",
    direction: "column",
    "&>div": {
      flex: 1,
      width: "100%",
    },
  },
  root: {
    padding: "0px 8px 0px 0px;",
  },
  title: {
    color: theme.HeaderSelectedText,
  },
  circularProgress: {
    color: theme.white,
  },
  actionButton: {
    textTransform: "none",
    minWidth: 120,
    "& $actionButtonDisabled": {
      cursor: "not-allowed",
      color: theme.iconColor,
      backgroundColor: theme.headerIconColor,
    },
    "&$actionOutlineDisabled": {
      borderColor: theme.iconColor,
      color: theme.iconColor,
    },
  },
  actionButtonDisabled: {
    backgroundColor: theme.HeaderSelectedText,
  },
  actionOutlineDisabled: {},
  actionContainer: {
    display: "flex",
    justifyContent: "space-around",
    paddingTop: "20px",
  },
  inputDisabled: { cursor: "not-allowed", background: theme.tooltipBGColor },
  errorMessage: {
    padding: "10px 0px",
    color: theme.palette.error.main,
    fontSize: theme.textFontSize,
  },

  errorMessageVisible: {
    color: theme.palette.error.main,
    fontSize: theme.textFontSize,
    marginTop: "8px",
    paddingLeft: "10px",
    marginBottom: "2px",
  },

  editTimeContainer: {
    marginTop: "0px",
    marginBottom: "6px",
    "&>div": {
      maxWidth: "100%",
      marginTop: 0,
      "&>div": {
        width: "100%",
        "&>div": {
          maxWidth: "100%",
          height: 40,
          borderRadius: 4,
          marginTop: 12,
        },
      },
    },
  },
  editTimeContainerError: {
    marginTop: "0px",
    marginBottom: "0px",
    "&>div": {
      maxWidth: "100%",
      marginTop: 0,
      "&>div": {
        width: "100%",
        "&>div": {
          maxWidth: "100%",
          height: 40,
          borderRadius: 4,
          borderColor: `${theme.ErrorMessageColor}`,
          color: `${theme.ErrorMessageColor}`,
          marginTop: 12,
        },
      },
    },
  },
  labelProps: {
    fontSize: theme.headerTextFontSize,
    backgroundColor: theme.ModalBGColor,
    color: theme.gridTextColor,
    padding: "0px 4px 0px 4px",
  },
  filledLabel: {
    top: 4,
    left: 8,
    "&$shrink": {
      transform: "translate(4px, 2px) scale(0.75)",
    },
  },
  shrink: {},
  timeEditorInput: {
    background: "transparent",
    "&:hover,&$timeEditorInputFocused": {
      background: "transparent",
    },
  },
  timeEditorInputFocused: {},
});

export default styles;
